import { capitalize } from '@sonar-software/sonar-ts-lib';
import { ClassificationLevel } from '@sonar-software/sonar-core';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Tag } from 'antd';
const classificationColors = {
    [ClassificationLevel.None]: '',
    [ClassificationLevel.Low]: 'purple',
    [ClassificationLevel.Medium]: 'gold',
    [ClassificationLevel.High]: 'orange',
    [ClassificationLevel.Critical]: 'red'
};
export const ClassificationTag = ({ classification }) => {
    if (classification === 'null') {
        return COPY_SPECIFIC.NONE;
    }
    return (React.createElement(Tag, { color: classificationColors[classification] }, capitalize(classification)));
};
